export default class LanguageSelector {
	private languageSelector: HTMLElement;
	public languageList: HTMLElement;
	private readonly documentClickCallback: EventListener;

	public constructor() {
		this.documentClickCallback = this.hideLanguageList;
		this.languageSelector = document.querySelector('.language-container a');
		this.languageList = document.querySelector('.language-container .language-list');
		this.languageSelector?.addEventListener('click', this.toggleVisibility);
	}

	private toggleVisibility = (event: MouseEvent): void => {
		event.preventDefault();
		event.stopPropagation();

		if (this.languageSelector.classList.contains('active')) {
			document.body.removeEventListener('click', this.documentClickCallback);
			this.languageSelector.classList.remove('active');
		} else {
			document.body.addEventListener('click', this.documentClickCallback);
			this.languageSelector.classList.add('active');
		}
	};

	private hideLanguageList = (event: MouseEvent): void => {
		const target: Element = event.target as Element;

		if (!target.classList.contains('active')) {
			document.body.removeEventListener('click', this.documentClickCallback);
			this.languageSelector.classList.remove('active');
		}
	};
}
